import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import InviteTeam from './InviteTeam'
import { Modal, useModals } from 'almanac-ui/Modal'

export const InviteTeamModal = () => {
  const workspace = useCurrentWorkspace()
  const { closeModal } = useModals()

  if (!workspace) return <div />

  return (
    <Modal.Root onPressOutside={closeModal} aria-label="Invite Team Members">
      <InviteTeam onClose={closeModal} workspace={workspace} />
    </Modal.Root>
  )
}
